import { render, staticRenderFns } from "./SellerTable.vue?vue&type=template&id=acd68dcc&scoped=true"
import script from "./SellerTable.vue?vue&type=script&lang=js"
export * from "./SellerTable.vue?vue&type=script&lang=js"
import style0 from "./SellerTable.vue?vue&type=style&index=0&id=acd68dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd68dcc",
  null
  
)

export default component.exports